import {Typography} from '@sollapay/ui';
import {formatDateLocalized} from '@sollapay/utils';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export interface DateCellProps {
  date?: string | Date | null;
  emptyPlaceholder?: string;
}

/** Locale-aware date cell — e.g. "01 באוק׳ 2023" / "01 Oct 2023". Shared by every table showing a plain date column (createdAt, uploadDate, birth date, …). */
export const DateCell: FC<DateCellProps> = ({date, emptyPlaceholder = '—'}) => {
  const {i18n} = useTranslation();

  return (
    <Typography size="sm" color="tertiary" className="tabular-nums">
      {date ? formatDateLocalized(date, i18n.language) : emptyPlaceholder}
    </Typography>
  );
};
